(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest(
        '[data-md-installation-play],[data-md-installation-cta]'
      );
      if (!trigger) return;

      var player = document.querySelector(
        '#MagdrainInstallationVideo[data-md-installation-player]'
      );
      var video = player && player.querySelector('.md-installation__video');
      if (!player || !video) return;

      event.preventDefault();
      player.classList.add('is-playing');

      if (trigger.matches('[data-md-installation-cta]')) {
        player.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
            ? 'auto'
            : 'smooth',
          block: 'center'
        });
      }

      var playAttempt = video.play();
      if (playAttempt && typeof playAttempt.catch === 'function') {
        playAttempt.catch(function () {
          video.controls = true;
        });
      }
    });

    var roots = document.querySelectorAll('[data-magdrain-product]');
    if (!roots.length) return;

    var productId =
      roots[0].getAttribute('data-product-id') ||
      (document.querySelector('[data-product-id]') &&
        document.querySelector('[data-product-id]').getAttribute('data-product-id'));
    var dataEl = document.getElementById('MagdrainVariants-' + productId);
    if (!dataEl) return;

    var variants = [];
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (error) {
      return;
    }

    var guide = document.getElementById('MagdrainSizeGuide');
    var selectedId =
      Number(guide && guide.getAttribute('data-selected-variant')) ||
      Number(variants[0] && variants[0].id);
    var syncing = false;

    function variantById(id) {
      id = Number(id);
      return variants.find(function (variant) {
        return Number(variant.id) === id;
      });
    }

    function money(cents) {
      var code =
        (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';
      try {
        return new Intl.NumberFormat('en-AU', {
          style: 'currency',
          currency: code
        }).format(Number(cents) / 100);
      } catch (error) {
        return '$' + (Number(cents) / 100).toFixed(2);
      }
    }

    function displayTitle(variant) {
      return String(variant.title || '').replace(/(\d)\s*mm\b/i, '$1 mm');
    }

    function mainForm() {
      return (
        document.querySelector(
          'product-form form[data-type="add-to-cart-form"][action*="/cart/add"]'
        ) ||
        document.querySelector(
          'form[data-type="add-to-cart-form"][action*="/cart/add"]'
        ) ||
        document.querySelector(
          'product-form form[action*="/cart/add"]:has([type="submit"])'
        )
      );
    }

    function mainVariantId() {
      var form = mainForm();
      var idInput = form && form.querySelector('[name="id"]');
      return Number(idInput && idInput.value);
    }

    function setProductFormIds(id) {
      document
        .querySelectorAll(
          'form[action*="/cart/add"] input[name="product-id"][value="' +
            productId +
            '"]'
        )
        .forEach(function (productInput) {
          var idInput = productInput.form && productInput.form.querySelector('[name="id"]');
          if (idInput) idInput.value = id;
        });
    }

    function syncMainOptions(variant) {
      if (!variant) return;
      var form = mainForm();
      if (!form) return;
      syncing = true;

      variant.options.forEach(function (optionValue) {
        var controls = document.querySelectorAll(
          'input[type="radio"][form], select[form], form[data-type="add-to-cart-form"] input[type="radio"], form[data-type="add-to-cart-form"] select'
        );

        Array.prototype.forEach.call(controls, function (control) {
          if (control.form !== form) return;

          if (
            control.matches('input[type="radio"]') &&
            control.value === optionValue &&
            !control.checked
          ) {
            control.click();
          }

          if (control.matches('select') && control.value !== optionValue) {
            var hasOption = Array.prototype.some.call(control.options, function (option) {
              return option.value === optionValue;
            });
            if (hasOption) {
              control.value = optionValue;
              control.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        });
      });

      setProductFormIds(variant.id);
      window.setTimeout(function () {
        setProductFormIds(variant.id);
        syncing = false;
        render(variant.id, true);
      }, 120);
    }

    function render(id, fromMain) {
      var variant = variantById(id);
      if (!variant) return;

      selectedId = Number(variant.id);
      var title = displayTitle(variant);
      var formattedPrice = money(variant.price);
      var dynamicLabel = variant.available
        ? 'Add ' + title + ' MAGdrain — ' + formattedPrice
        : title + ' MAGdrain unavailable';

      document.querySelectorAll('[data-md-size-card]').forEach(function (card) {
        var selected =
          Number(card.getAttribute('data-variant-id')) === selectedId;
        card.classList.toggle('is-selected', selected);
        var button = card.querySelector('[data-md-select-variant]');
        if (button) button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      document.querySelectorAll('[data-md-selected-title]').forEach(function (el) {
        el.textContent = title;
      });
      document.querySelectorAll('[data-md-selected-price]').forEach(function (el) {
        el.textContent = formattedPrice;
      });
      document
        .querySelectorAll('[data-md-selected-availability]')
        .forEach(function (el) {
          el.textContent = variant.available ? 'In stock' : 'Unavailable';
          el.classList.toggle('md-in-stock', variant.available);
          el.classList.toggle('md-out-stock', !variant.available);
        });
      document.querySelectorAll('[data-md-stock-message]').forEach(function (el) {
        el.textContent = variant.available
          ? 'Selected model available'
          : 'Selected model unavailable';
      });
      document.querySelectorAll('[data-md-add]').forEach(function (button) {
        button.disabled = !variant.available;
        if (button.getAttribute('data-md-add-label') === 'dynamic') {
          button.textContent = dynamicLabel;
        }
        if (button.getAttribute('data-md-add-label') === 'compact') {
          button.textContent = variant.available ? 'Add to Cart' : 'Unavailable';
        }
      });

      if (!fromMain) syncMainOptions(variant);
    }

    function syncQuantities(value, source) {
      value = Math.max(1, Number(value) || 1);
      document.querySelectorAll('[data-md-qty]').forEach(function (input) {
        if (input !== source) input.value = value;
      });
      var form = mainForm();
      var mainQuantity = form && form.querySelector('[name="quantity"]');
      if (mainQuantity && mainQuantity !== source) {
        mainQuantity.value = value;
        mainQuantity.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    document.addEventListener('click', function (event) {
      var select = event.target.closest('[data-md-select-variant]');
      if (select) {
        event.preventDefault();
        render(select.getAttribute('data-md-select-variant'), false);
        return;
      }

      var add = event.target.closest('[data-md-add]');
      if (!add) return;

      event.preventDefault();
      var variant = variantById(selectedId);
      var form = mainForm();
      if (!variant || !variant.available || !form) return;

      syncMainOptions(variant);
      var localPanel = add.closest('.md-selection-summary,.md-final-panel');
      var localQuantity = localPanel && localPanel.querySelector('[data-md-qty]');
      syncQuantities(localQuantity ? localQuantity.value : 1, localQuantity);
      setProductFormIds(variant.id);

      window.setTimeout(function () {
        setProductFormIds(variant.id);
        if (form.requestSubmit) {
          form.requestSubmit();
        } else {
          form.submit();
        }
      }, 140);
    });

    document.addEventListener('change', function (event) {
      if (event.target.matches('[data-md-qty]')) {
        syncQuantities(event.target.value, event.target);
        return;
      }

      var form = mainForm();
      if (!form || event.target.form !== form || syncing) return;

      window.setTimeout(function () {
        var id = mainVariantId();
        if (variantById(id)) render(id, true);
      }, 140);
    });

    document.addEventListener('input', function (event) {
      var form = mainForm();
      if (event.target.matches('[data-md-qty]')) {
        syncQuantities(event.target.value, event.target);
        return;
      }
      if (
        form &&
        event.target.form === form &&
        event.target.matches('[name="quantity"]')
      ) {
        var value = Math.max(1, Number(event.target.value) || 1);
        document.querySelectorAll('[data-md-qty]').forEach(function (input) {
          input.value = value;
        });
      }
    });

    document.addEventListener('variant:change', function (event) {
      var id =
        event.detail &&
        event.detail.variant &&
        Number(event.detail.variant.id);
      if (variantById(id)) render(id, true);
    });

    var form = mainForm();
    if (form) {
      var idInput = form.querySelector('[name="id"]');
      var quantityInput = form.querySelector('[name="quantity"]');
      if (idInput && variantById(idInput.value)) selectedId = Number(idInput.value);
      if (quantityInput) syncQuantities(quantityInput.value, quantityInput);
    }
    render(selectedId, true);

    var mobile = document.querySelector('[data-md-mobile-bar]');
    if (mobile) {
      var primary = document.querySelector('product-info,.product');
      var updateBar = function () {
        if (window.innerWidth > 640) {
          mobile.classList.remove('is-visible');
          return;
        }
        var show = primary
          ? primary.getBoundingClientRect().bottom < 0
          : window.scrollY > 650;
        mobile.classList.toggle('is-visible', show);
      };
      window.addEventListener('scroll', updateBar, { passive: true });
      window.addEventListener('resize', updateBar);
      updateBar();
    }
  });
})();
